import { FileManager } from "tir-pm-file-upload-manager";
import {
  FileApiService,
  ImportFileApiService,
  ImportVideoApiService,
  VideoApiService,
} from "./services";

export const initFileUploadManager = () => {
  FileManager.init(
    new FileApiService(),
    new VideoApiService(),
    new ImportFileApiService(),
    new ImportVideoApiService()
  );
};
